// url
export default "http://johnsmilgatutorials.com/projects/react-tech-store-v2/products";
